export type SimpleInvoiceResponse = {
  id: number
  invoiceId: number
  amount: string
  date: string
  date_display: string
  status: InvoiceStatus
}

export type InvoiceDownloadResponse = {
  resourceId: string
  clientId: number
  resourceType: string
  shareLink: string
  shareMethod: string
}

export type UpgradeSubscriptionQueryArgs = {
  card_holder_name: string
  card_number: string
  expire_month: string
  expire_year: string
  cvv: string
  country: string
  phone_number: string
  package_type: string
  amount: number
}

export type UpdateCreditCardQueryArgs = {
  card_holder_name: string
  card_number: string
  expire_month: string
  expire_year: string
  cvv: string
  country: string
  phone_number: string
}

export type OneTimePaymentArg = {
  c: number
}

type InvoiceStatus =
  | 'disputed'
  | 'draft'
  | 'sent'
  | 'viewed'
  | 'paid'
  | 'auto-paid'
  | 'retry'
  | 'failed'
  | 'partial'

export enum PlanPackageType {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export const DynamicPricingFeatures = [
  PlanPackageType.S,
  PlanPackageType.M,
  PlanPackageType.L,
  PlanPackageType.XL,
]

export const PremiumFeatures = [
  PlanPackageType.M,
  PlanPackageType.L,
  PlanPackageType.XL,
]

export const PlatinumFeatures = [PlanPackageType.L, PlanPackageType.XL]
